<template>
  <figure class="highcharts-figure">
    <highcharts ref="chart" :options="options" />
    <p class="highcharts-description highcharts-linked-description">
      <strong>Figure : </strong>
      {{ $t('compGraphicsDevicesEmissionsFactors.help') }}
    </p>
  </figure>
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'DevicesEmissionsFactors',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    series: function () {
      let series = [
        {
          name: this.$t('usage'),
          data: []
        },
        {
          name: this.$t('eol'),
          data: []
        },
        {
          name: this.$t('transportation'),
          data: []
        },
        {
          name: this.$t('manufacturing'),
          data: []
        }
      ]
      // add smartphone
      series[0].data.push(0)
      series[1].data.push(0)
      series[2].data.push(0)
      series[3].data.push(63)
      // add laptop1
      series[0].data.push(5)
      series[1].data.push(10)
      series[2].data.push(10)
      series[3].data.push(180)
      // add laptop2
      series[0].data.push(5)
      series[1].data.push(10)
      series[2].data.push(20)
      series[3].data.push(304)
      // add desktop
      series[0].data.push(5)
      series[1].data.push(10)
      series[2].data.push(40)
      series[3].data.push(380)
      // add screen
      series[0].data.push(5)
      series[1].data.push(10)
      series[2].data.push(40)
      series[3].data.push(430)
      // add screen
      series[0].data.push(5)
      series[1].data.push(10)
      series[2].data.push(40)
      series[3].data.push(1300)
      return series
    },
    categories: function () {
      return [
        this.$t('smartphone'),
        this.$t('laptop1'),
        this.$t('laptop2'),
        this.$t('desktop'),
        this.$t('screen'),
        this.$t('server')
      ]
    },
    options: function () {
      let self = this
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.categories
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('compGraphicsDevicesEmissionsFactors.kg.co2e.km')
          }
        },
        tooltip: {
          formatter: function () {
            let tooltip = this.points[0].x + ' <br />'
            for (let i in this.points) {
              tooltip +=
                '<span style="color:' +
                this.points[i].series.color +
                ';">\u25CF ' +
                '</span> '
              tooltip +=
                this.points[i].series.name +
                ': <b>' +
                Math.round(this.points[i].y * 10000) / 10000
              tooltip +=
                '</b> ' +
                self.$t('compGraphicsDevicesEmissionsFactors.kg.co2e.km') +
                ' <br />'
            }
            return tooltip
          },
          shared: true
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: this.series
      }
    }
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
